import * as tslib_1 from "tslib";
import { AbstractionBase } from "@awayjs/core";
import { ChunkVO } from "../data/ChunkVO";
/**
 * CompositeChunkBase provides a base class for diffuse methods that wrap a diffuse method to alter the
 * calculated diffuse reflection strength.
 */
var CompositeChunkBase = (function (_super) {
    tslib_1.__extends(CompositeChunkBase, _super);
    /**
     * Creates a new <code>CompositeChunkBase</code> object.
     *
     * @param modulateMethod The method which will add the code to alter the base method's strength. It needs to have the signature clampDiffuse(t:ShaderRegisterElement, regCache:ShaderRegisterCache):string, in which t.w will contain the diffuse strength.
     * @param baseMethod The base diffuse method on which this method's shading is based.
     */
    function CompositeChunkBase(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this.chunkVO = new ChunkVO();
        _this._baseChunk = shader.getAbstraction(method.baseMethod);
        return _this;
    }
    CompositeChunkBase.prototype._isUsed = function () {
        return true;
    };
    CompositeChunkBase.prototype._usesTangentSpace = function () {
        return this._baseChunk._usesTangentSpace();
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._initVO = function (chunkVO) {
        this._baseChunk._initVO(chunkVO);
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._initConstants = function () {
        this._baseChunk._initConstants();
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._activate = function () {
        this._baseChunk._activate();
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._setRenderState = function (renderable, projection) {
        this._baseChunk._setRenderState(renderable, projection);
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._deactivate = function () {
        this._baseChunk._deactivate();
        this._invalid = false;
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._getVertexCode = function (registerCache, sharedRegisters) {
        return this._baseChunk._getVertexCode(registerCache, sharedRegisters);
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        return this._baseChunk._getFragmentCode(targetReg, registerCache, sharedRegisters);
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._reset = function (chunkVO) {
        this._baseChunk._reset(chunkVO);
        this._invalid = true;
        this._cleanCompilationData();
    };
    /**
     * @inheritDoc
     */
    CompositeChunkBase.prototype._cleanCompilationData = function () {
        this._baseChunk._cleanCompilationData();
    };
    return CompositeChunkBase;
}(AbstractionBase));
export { CompositeChunkBase };



// WEBPACK FOOTER //
// ../dist/lib/chunks/CompositeChunkBase.js